export function getApiOrigin(backUrl: string): string {
	return backUrl.replace(/\/panel\/?$/, '');
}

export function normalizeWebviewPreviewUrl(url: string): string | null {
	const trimmed = url.trim();
	if (!trimmed) {
		return null;
	}
	if (/^https?:\/\//i.test(trimmed)) {
		return trimmed;
	}
	return `https://${trimmed}`;
}